import { render, staticRenderFns } from "./userAgreement.vue?vue&type=template&id=61d71314&scoped=true&"
import script from "./userAgreement.vue?vue&type=script&lang=js&"
export * from "./userAgreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d71314",
  null
  
)

export default component.exports